export default {
    // Web网页访问路径
    webUrl: "https://zqsq.cc",
    // 接口访问路径
    apiUrl: "https://api.91zuqu.com:9000",
};
